import useLmmStore from '../../state/useLmmStore';

import LmmTableMaterieelHeaders from './LmmTableMaterieelHeaders';
import LmmTableMaterieelRow from './LmmTableMaterieelRow';
import LmmTableMaterieelRowSubHeader from './LmmTableMaterieelRowSubHeader';
import LmmTableMaterieelTijdstipHeader from './LmmTableMaterieelTijdstipHeader';

import styles from './LmmTableMaterieel.module.css';
export default function LmmTableMaterieel() {
  const lmmMaterieelTimed = useLmmStore((state) => Array.from(state.lmmMaterieelTimed.entries()));
  // Rows keep their overall sort order (by materieel or by open tijdstip's over/tekort), but are
  // split into separate Intercities/Sprinters sections, per design.
  const intercities = lmmMaterieelTimed.filter((entry) => entry[1].NU.matCategory === 'intercity');
  const sprinters = lmmMaterieelTimed.filter((entry) => entry[1].NU.matCategory === 'sprinter');

  return (
    <div className={styles.table}>
      <LmmTableMaterieelTijdstipHeader />
      <LmmTableMaterieelHeaders />
      <LmmTableMaterieelRowSubHeader subHeader='Intercities' />
      {intercities.map(([materieel, materieelTimed]) => (
        <LmmTableMaterieelRow key={materieel} materieel={materieel} materieelTimed={materieelTimed} />
      ))}
      <LmmTableMaterieelRowSubHeader subHeader='Sprinters' />
      {sprinters.map(([materieel, materieelTimed]) => (
        <LmmTableMaterieelRow key={materieel} materieel={materieel} materieelTimed={materieelTimed} />
      ))}
    </div>
  );
}
